import { AxiosError, AxiosResponse } from "axios";

export const invalidTokenResponseInterceptor = (cb: Function) => (
  err: AxiosError,
) => {
  const response: AxiosResponse | undefined = err.response;

  if (response?.status === 401) {
    cb(response);
  }

  return Promise.reject(err);
};
